import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { DashboardDespesa } from '../domain/dashboard-despesa.model';

export class DashBoardDespesaSerializer extends DomainSerializer<DashboardDespesa> { }
